export default [
    {
        path: "/",
        name: "home",
        component: () => import("@/views/Home.vue"),
    },
    {
        path: "/premium-link-generator",
        name: "premium-link-home",
        component: () => import("@/views/Home.vue"),
        meta: {
            title: "Premium Link generator Rapidgator, Emload, Katfile and more - Leechall.io",
        },
    },
    {
        path: "/status",
        name: "status",
        component: () => import("@/views/status/Status.vue"),
        meta: { title: "Status - Leechall.io" },
    },
    {
        path: "/plans",
        name: "plans",
        component: () => import("@/views/plans/Plans.vue"),
        meta: { title: "Plans - Leechall.io" },
    },
    {
        path: "/support",
        name: "support",
        component: () => import("@/views/support/Support.vue"),
        meta: { title: "Support - Leechall.io" },
    },
    {
        path: "/terms",
        name: "terms",
        component: () => import("@/views/terms/Terms.vue"),
        meta: { title: "Terms of Use - Leechall.io" },
    },
    {
        path: "/privacy",
        name: "privacy",
        component: () => import("@/views/privacy/Privacy.vue"),
        meta: { title: "Privacy - Leechall.io" },
    },
    {
        path: "/resellers",
        name: "resellers",
        component: () => import("@/views/resellers/Resellers.vue"),
        meta: { title: "Resellers - Leechall.io" },
    },
    {
        path: "/resellers/panel",
        name: "resellers-panel",
        component: () => import("@/views/resellers/ResellerPanel.vue"),
        meta: { title: "Resellers Panel - Leechall.io" },
    },
    {
        path: "/profile",
        name: "profile",
        component: () => import("@/views/profile/Profile.vue"),
        meta: {
            title: "Profile - Leechall.io",
            requiresAuth: true,
        },
    },
    {
        path: "/downloader",
        name: "downloader",
        component: () => import("@/views/downloader/Downloader.vue"),
        meta: {
            title: "Downloader - Leechall.io",
            requiresAuth: true,
        },
    },
    {
        path: "/download/:hash",
        name: "download",
        component: () => import("@/views/downloader/Download.vue"),
        meta: {
            title: "Download file - Leechall.io",
            requiresAuth: true,
        },
    },
    {
        path: "/history",
        name: "download-history",
        component: () => import("@/views/downloader/History.vue"),
        meta: {
            title: "History - Leechall.io",
            requiresAuth: true,
        },
    },
    {
        path: "/voucher",
        name: "voucher",
        component: () => import("@/views/voucher/RedeemVoucher.vue"),
        meta: {
            title: "Redeem Voucher - Leechall.io",
            requiresAuth: true,
        },
    },
    {
        path: "/premium/:plan_id/:payment_id",
        name: "payment-summary",
        component: () => import("@/views/payment/PaymentSummary.vue"),
        meta: {
            title: "Payment Summary - Leechall.io",
            requiresAuth: true,
        },
    },

    {
        path: "/payment/success",
        name: "payment-success",
        component: () => import("@/views/payment/PaymentSuccess.vue"),
        meta: { title: "Payment Success - Leechall.io" },
    },
    {
        path: "/payment/failed",
        name: "payment-failed",
        component: () => import("@/views/payment/PaymentFailed.vue"),
        meta: { title: "Payment Failed - Leechall.io" },
    },
    {
        path: "/premium-link-generator/:host",
        name: "premium-link-generator",
        component: () => import("@/views/downloader/PremiumLinkGenerator.vue"),
    },
];
